import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CheckboxComponent, DialogService } from '@sircon/sircon-ui-framework';
import { EnvService } from 'src/services/env.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-browser-unsupported',
    templateUrl: './browser-unsupported.component.html',
    imports: [CheckboxComponent, FormsModule]
})
export class BrowserUnsupportedComponent {
    doNotShow: string;

    constructor(private cookieService: CookieService,
                private dialogService: DialogService,
                private env: EnvService) {
    }

    closeDialog() {
        this.cookieService.set(this.env.storageKeys.BROWSER_UNSUPPORTED, this.doNotShow, this.env.COOKIES_OPTIONS);
        this.dialogService.close('browser-unsupported-dialog');
    }
}
